import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import { Button, Container, Col, Row, Label } from 'reactstrap'
import DataWrapper from '../../../principal/containers/DataWrapper'
import EntradaAntecipadaStore from '../stores/EntradaAntecipadaStore'
import { FiltroEntradaAntecipada } from '../components/FiltroEntradaAntecipada'
import { TabelaRegistros } from '../components/TabelaRegistros'
import ModalNovaSolicitacao from '../components/ModalNovaSolicitacao'
import LoadingImage from '../../../comum/components/LoadingImage'
import Termo from '../components/TermoDeAceite'
import ConfirmaModal from '../components/ConfirmaModal';
import FooterContent from '../../../comum/components/FooterContent';
import Footer from "../../../comum/components/Footer";
import ModalForm from "../../../comum/components/ModalForm";
import ModalAviso from "../../../comum/components/ModalAviso";
// import FooterModal from "../../comum/components/FooterModal"
// import { Label } from "reactstrap";
// import { ModalContainer, ModalDialog } from 'react-modal-dialog';



@inject("store")
@DataWrapper
@observer

export class EntradaAntecipada extends Component{
    constructor(props){
        super(props)
        this.appStore = this.props.store.appStore;
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
        this.logignStore = this.props.store.loginStore;
        this.controller = new EntradaAntecipadaStore();
    }
    componentDidMount(){
        this.tituloPaginaStore.setTitulo("Entrada Antecipada");
        this.appStore.showTopbar(true);
        this.controller.carregarSituacaoEntradaAntecipada()
    };

    toolBar(){
        return (
            <Row>
                <Col className="justify-content-end d-flex mb-0">
                    <Button className="btn-com-bordas-primary" onClick={() => this.controller.setEstadoModal(true)} disabled={!this.controller.entradaAntecipadaLiberada}>
                        Nova Solicitação
                    </Button>
                </Col>
            </Row>
        )
    }

    modalTermo = () => {
        if (this.controller.modalTermo)
          // TODO Remover negação
          return <Termo controller={this.controller} />;
        
      };

      chamaRotina = () =>{
       this.controller.verificaTermo()
    }

    modalConfirmaInativar = () => {
        if (this.controller.modalInativar)
            return <ModalForm labelCancelar="NÃO"
                              labelConfirmar="SIM"
                              salvando={this.controller.inativandoLoading}
                              onClickCancelar={ () => this.controller.cancelaInativar() }
                              onClickSalvar={ () => this.controller.confirmarInativar() }>
                { this.controller.selecionados.length === 1
                    ? <h2>Deseja inativar a Solicitação selecionada?</h2>
                    : <h2>Deseja inativar as Solicitações selecionadas?</h2>
                }
            </ModalForm>
    };


  
    ChamaModalConfirma = () => {
        if (this.controller.confirmaModal)
            return <ConfirmaModal controller={this.controller}/>;
    }

    aviso = () => {
        console.log('teste', this.controller.Erros)
            // if (this.controller.Erros){
                console.log('entrou no if', console.log(this.controller.listaMensagens))
           
            // }
        };


    render(){
        return (
            <div className="form-wrapper">
            { this.aviso}
             {this.ChamaModalConfirma()}
               {/* {this.chamaRotina()} */}
                {this.modalTermo()}
               { this.modalConfirmaInativar() }
                <Container className="tela-botoes-inclusao-topo" fluid>
                    {this.controller.modalNovaSolicitacao && <ModalNovaSolicitacao controller={this.controller} />}
                    { this.controller.listaMensagens && this.controller.listaMensagens.length > 0 && 
                    <ModalAviso onClickFechar={ () => {this.controller.listaMensagens = false;this.controller.setEstadoModalSolicitacao(false)} } >
                    { this.controller.listaMensagens.map((msg, x) =>
                        <p key={x}>{ msg }</p>
                    )}
                    </ModalAviso>}
                    {this.toolBar()}
                    <FiltroEntradaAntecipada controller={this.controller} />
                    {
                        this.controller.carregandoTabela ? <LoadingImage /> : <TabelaRegistros controller={this.controller} /> 
                    }
                </Container>
                
                <Footer>
                <FooterContent className="right-pos">
                             { <div>
                                    <Button disabled={ this.controller.selecionados.length===0 }  className="btn-primary" onClick={ () => this.controller.abrirModalInativar() }>INATIVAR LIBERAÇÃO</Button>                                
                            </div> }
                </FooterContent>
                </Footer>
            </div>
        )
        
    };
};


// WEBPACK FOOTER //
// ./src/modules/agendamento/entrada-antecipada/telas/EntradaAntecipada.js